import { State } from '../state';

export const SensorDetailSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    sensorDetailRowData: (state: State) => state.SensorDetailReport,
    sensorDetailRowLoading: (state: State): boolean => state.SensorDetailReport.loading,
    sensorDetailRowSuccess: (state: State): boolean => state.SensorDetailReport.success,
};
